// import cookies from 'js-cookie'
const common = {
  state: {
    homeScrollTop: 0, //首页滚动高度
    showTabbar: true,
    source: false,
    timer: 0, // 评论倒计时
    showCourseDetailServe: false, //显示精品课详情客服按钮
    showCampDetailServe: true, //显示特训营详情客服按钮
    showQcode: false
  },
  mutations: {
    SET_CAMP_DETAIL_SERVE: (state, value) => {
      state.showCampDetailServe = value
    },
    SET_COURSE_DETAIL_SERVE: (state, value) => {
      state.showCourseDetailServe = value
    },
    SET_HOME_SCROLL_TOP: (state, value) => {
      state.homeScrollTop = value
    },
    SET_SHOW_TABBAR: (state, value) => {
      state.showTabbar = value
    },
    SET_SOURCE: (state, value) => {
      state.source = value
    },
    SET_TIMER: (state, value) => {
      state.timer = value
    },
    SET_SHOW_QCODE: (state, value) => {
      state.showQcode = value
    }
  },
  actions: {
    setCampDetailServe: ({ commit }, value) => {
      return commit('SET_CAMP_DETAIL_SERVE', value)
    },
    setCourseDetailServe: ({ commit }, value) => {
      return commit('SET_COURSE_DETAIL_SERVE', value)
    },
    setHomeScrollTop: ({ commit }, value) => {
      return commit('SET_HOME_SCROLL_TOP', value)
    },
    setShowTabbar: ({ commit }, value) => {
      return commit('SET_SHOW_TABBAR', value)
    },
    setSource: ({ commit }, value) => {
      return commit('SET_SOURCE', value)
    },
    setTimer: ({ commit }, value) => {
      return commit('SET_TIMER', value)
    },
    setshowQcode: ({ commit }, value) => {
      return commit('SET_SHOW_QCODE', value)
    }
  }
}

export default common
